import confirmationTextAreaPopupComponent from './confirmationTextAreaPopup.component';
import popupModule from '../index';

const confirmationTextAreaPopupModule = angular.module('app.common.ertConfirmationTextAreaPopup', [popupModule])
	.component('ertConfirmationTextAreaPopup', confirmationTextAreaPopupComponent)
	.name;

export default confirmationTextAreaPopupModule;
